import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { CaseModuleRoutes } from '@app/modules/case/case-routes';

@Component({
  selector: 'case-navigation',
  templateUrl: './case-navigation.component.html',
  styleUrls: ['./case-navigation.component.scss']
})
export class CaseNavigationComponent extends BaseComponent implements OnInit {

  public caseId: string;

  public detailedCasePages: { page: string, pageDetail: string, title: string, isActive: boolean }[] = [
    { page: '', pageDetail: CaseModuleRoutes.GENERAL , title: marker('detailed_processing.navigation.general'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.PARTICIPANTS, title: marker('detailed_processing.navigation.participants'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.VEHICLE, title: marker('detailed_processing.navigation.vehicle'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.ACCIDENT_DESCRIPTION, title: marker('detailed_processing.navigation.accident_description'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.ACCIDENT_OPPONENT, title: marker('detailed_processing.navigation.accident_opponent'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.ATTACHMENTS, title: marker('detailed_processing.navigation.attachments'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.DISTRIBUTION, title: marker('detailed_processing.navigation.distribution'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.RESULTS, title: marker('detailed_processing.navigation.results'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.LAWYER, title: marker('detailed_processing.navigation.lawyer'), isActive: false },
    { page: '', pageDetail: CaseModuleRoutes.SUMMARY, title: marker('detailed_processing.navigation.summary'), isActive: false }
  ];

  constructor(private route: ActivatedRoute, private router: Router) {
    super();
    this._idPrefix = 'case_detailed_navigation.';
    this.detailedCasePages.forEach(detailedPage => {
      detailedPage.page =`${CaseModuleRoutes.DETAILED_PROCESSING}/${detailedPage.pageDetail}`
    });
  }

  public ngOnInit() {
    super.ngOnInit();
    this.caseId = this.route.snapshot.paramMap.get('id');
    this.checkActivePage();
  }

  private checkActivePage(): void {
    const currentRoute = this.router.routerState.snapshot.url.replace(this.caseId, ':id');
    this.detailedCasePages.forEach(detailedPage => detailedPage.isActive = `/${detailedPage.page}` === currentRoute);
  }

  public navigateTo(casePage: string): void {
    this.router.navigateByUrl(casePage.replace(':id', this.caseId))
               .then(() => {
                  this.checkActivePage();
               });
  }

}
